import { Hammer, Volume1, Leaf, ThermometerSun, Wifi, Move, Building2 } from "lucide-react";
import { SectionHead } from "./SectionHead";
import { IMAGES } from "@/lib/product";

const BENEFITS = [
  ["notools", Hammer, "Performance split, sans travaux", "L'efficacité d'un climatiseur split, sans carottage ni frigoriste. La liaison préassemblée passe simplement par la fenêtre."],
  ["silent", Volume1, "Silencieux : 39 dB(A)", "Le compresseur est dans l'unité extérieure et l'appareil bénéficie d'une isolation triple couche. Idéal pour dormir ou travailler."],
  ["efficiency", Leaf, "Classe A++ en froid", "SEER 6,1 en refroidissement, A+ en chauffage (SCOP 4,0). Plus de confort pour chaque kWh consommé."],
  ["reversible", ThermometerSun, "Réversible chaud / froid", "4-en-1 : climatisation, chauffage par pompe à chaleur, déshumidification et ventilation. Une seule machine pour toute l'année."],
  ["smart", Wifi, "Wi-Fi & commande vocale", "Pilotage à distance avec l'app Midea SmartHome, compatible Amazon Alexa, Google Home et Siri. Rentrez dans une pièce déjà fraîche."],
  ["mobile", Move, "Mobile, pièce à pièce", "L'unité intérieure est montée sur roulettes : salon le jour, chambre la nuit. Vous déménagez ? Elle vous suit."],
  ["tenants", Building2, "Idéal locataires & copropriété", "Aucune unité fixée en façade ni perçage : pas de travaux nécessitant une autorisation comme pour un split fixe. Vérifiez simplement votre règlement pour l'accrochage en fenêtre."],
];

export const Benefits = () => (
  <section id="avantages" data-testid="benefits-section" className="section bg-ice-soft">
    <div className="container-x">
      <SectionHead
        eyebrow="Avantages"
        title="Tout ce qu'un split fixe sait faire. Sans ses contraintes."
        text="Le PortaSplit sépare le bruit et la chaleur du compresseur de votre pièce de vie, comme une climatisation murale — mais s'installe et se déplace comme un appareil mobile."
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
        {BENEFITS.map(([id, Icon, title, desc], i) => (
          <article key={id} data-testid={`benefit-card-${id}`} className={`benefit-card ${i === 0 ? "lg:col-span-2" : ""}`}>
            <span className="icon-ice"><Icon className="w-6 h-6" /></span>
            <h3 className="font-display text-lg sm:text-xl font-bold text-slate-900 mt-5">{title}</h3>
            <p className="text-slate-600 leading-relaxed mt-2 text-[15px]">{desc}</p>
          </article>
        ))}
      </div>
      <div className="grid md:grid-cols-[1.15fr_1fr] gap-5 mt-5 items-start">
        <figure data-testid="benefit-silent-image" className="benefit-card !p-3 sm:!p-4 flex flex-col gap-3">
          <img src={IMAGES.silence} alt="Fonctionnement silencieux : 39 dB en mode silencieux" className="w-full h-auto object-contain rounded-xl" loading="lazy" />
          <figcaption className="px-2 pb-1 text-sm text-slate-600"><strong className="text-slate-900">Silencieux : 39 dB(A)</strong> — moins qu'une bibliothèque.</figcaption>
        </figure>
        <figure data-testid="benefit-smart-image" className="benefit-card !p-3 sm:!p-4 flex flex-col gap-3">
          <img src={IMAGES.app} alt="Gestion intelligente avec l'application SmartHome, compatible Alexa et Google Home" className="w-full h-auto object-contain rounded-xl" loading="lazy" />
          <figcaption className="px-2 pb-1 text-sm text-slate-600"><strong className="text-slate-900">Wi-Fi & commande vocale</strong> — pilotez-le depuis l'app SmartHome.</figcaption>
        </figure>
      </div>
    </div>
  </section>
);
